module.exports = "https://cdn.hellotech.com/client-assets/lock_square_315953bd71d1428b90f1f9362e42fd47.jpg";